import { render, staticRenderFns } from "./ProgramarCurso.vue?vue&type=template&id=cfa3df7c&scoped=true"
import script from "./ProgramarCurso.vue?vue&type=script&lang=js"
export * from "./ProgramarCurso.vue?vue&type=script&lang=js"
import style0 from "./ProgramarCurso.vue?vue&type=style&index=0&id=cfa3df7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa3df7c",
  null
  
)

export default component.exports